<y42-context-menu-color-button
  [color]="borderColor"
  [tooltip]="label"
  (colorChanged)="borderColorChanged.emit($event)"
></y42-context-menu-color-button>
